export const TOUCH_DIAGNOSTICS_FLAG_KEY = 'ecomm.kiosk-pro-touch-diagnostics.operational';

// MPX Sandbox (server: ianthus, LSP: 1670) dispensary ID.
// Verified via dutchie.com/graphql filteredDispensaries cName query.
export const MPX_SANDBOX_DISPENSARY_ID = '65c10de35125cf000935f594';

export const DIAGNOSTICS_LOGGER_NAMESPACE = 'kiosk-touch-diagnostics';

export const DEFAULT_HIT_MAP_INTERVAL_MS = 60000;
export const MIN_HIT_MAP_INTERVAL_MS = 5000;

export const BAR_TEST_ID = 'kiosk-pro-consumer-info-panel';

export const BUTTON_TEST_IDS = [
  'kiosk-pro-end-session-button',
  'kiosk-pro-go-to-cart-button',
  'kiosk-pro-login-button',
  'kiosk-pro-order-history-button',
] as const;
